import { useEffect } from 'react'

import { useHistory, useParams } from 'react-router-dom'

import { Paths } from 'constants/index'

const SUBMIT_BID_PARAM = 'submitBid'
const AVAILABLE_LOADS_HASH = 'dashboard-available-loads'

/**
 * Universal Link / App Link landing page for the "Bid for this Job" driver email, SMS,
 * and push-notification links (`/driver/bid/:bookingId`). On a device with the OnePoint
 * driver app installed, iOS/Android intercept this URL before it ever reaches the
 * browser. This component only runs as the fallback — when the app isn't installed, or
 * the OS didn't hand the link to it — and forwards into the existing dashboard bid
 * dialog so the web flow stays unchanged.
 */
export default function DriverBidRedirect() {
  const { bookingId } = useParams<{ bookingId: string }>()
  const { replace } = useHistory()

  useEffect(() => {
    replace(`${Paths.dashboard.all}?${SUBMIT_BID_PARAM}=${bookingId}#${AVAILABLE_LOADS_HASH}`)
  }, [bookingId, replace])

  return null
}
